import axios from 'axios'

export default {
    namespaced: true,
    state: {
        countries: [],
        maritalStatuses: [],
        fundingTypes: [],
    },
    mutations: {
        SET_COUNTRIES(state, payload) {
            state.countries = payload;
        },
        SET_MARITAL_STATUSES(state, payload) {
            state.maritalStatuses = payload;
        },
        SET_FUNDING_TYPES(state, payload) {
            state.fundingTypes = payload;
        },
    },
    actions: {
        async FetchCountries({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/lookups/countries`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_COUNTRIES', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchCountries: ${error.message}`));
            });
        },
        async FetchMaritalStatuses({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/lookups/marital-statuses`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_MARITAL_STATUSES', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchMaritalStatuses: ${error.message}`));
            });
        },
        async FetchFundingTypes({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/lookups/funding-types`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_FUNDING_TYPES', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchFundingTypes: ${error.message}`));
            });
        },
    },
    getters: {
        Countries(state) { return state.countries; },
        MaritalStatuses(state) { return state.maritalStatuses; },
        FundingTypes(state) { return state.fundingTypes; },
    }
};
